import Dashboard from "../../dashboard/Dashboard";
import Button from "../../../components/buttons/Button";
import "../../../components/generalComponents.scss";
import style from "../../reviews/review.module.scss";
import { faArrowLeftLong } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { GetLanguageRequest } from "../types";
import { useEffect, useState } from "react";
import { getDetails, updateData } from "../../../services/review.service";
import { ActionType } from "../../../utils/constants";
import showToast from "../../../utils/show.toast";
import formatDate from "../../../utils/date.formater";

function useQuery() {
  return new URLSearchParams(useLocation().search);
}

export default function LanguageToTeachDetails() {
  const router = useNavigate();
  const [action, setAction] = useState<string | null>(null);
  const { requestId } = useParams();
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | undefined>();

  const navigate = useNavigate();
  const query = useQuery();
  const status = query.get("status");

  const [languageTaught, setLanguageTaughtDetail] =
    useState<GetLanguageRequest | null>({
      id: 0,
      merchantTeacherEmail: "",
      merchantFirstName: "",
      requestedAt: "",
      merchantId: 0,
    });

  const fetchDetails = async () => {
    try {
      const endpoint = `teachers/${requestId}/language-update`;
      const response = await getDetails(endpoint);

      if (response.status === "success") {
        setLanguageTaughtDetail(response.result);
      } else {
        showToast(response.message || "Failed to fetch languages", false);
      }
    } catch (err: any) {
      const message = err?.message || "An error occurred";
      showToast(message, false);
    }
  };

  const handleStatusUpdate = async (
    statusToUpdate: ActionType,
    actionName: string
  ) => {
    setAction(actionName);
    try {
      const endpoint = `teachers/${requestId}/language-update`;
      await updateData(endpoint, {
        reqid: Number(requestId),
        action: statusToUpdate,
      });
      showToast(
        `Merchant ${statusToUpdate.toLocaleLowerCase()} successfully!`,
        true
      );

      setAction(null);
      return navigate(`/review/language-to-teach/list?status=${status}`);
    } catch (error) {
      const message =
        error instanceof Error
          ? error.message
          : "Apologies, an unexpected error occured!";

      showToast(message, false);
      setAction(null);
    }
  };

  useEffect(() => {
    fetchDetails();
  }, []);

  return (
    <Dashboard>
      {loading && <p className={style.textStyle}>Loading Requests...</p>}

      <>
        <div style={{ display: "flex" }}>
          <FontAwesomeIcon
            icon={faArrowLeftLong}
            onClick={() => router(-1)}
            style={{
              marginTop: "1px",
              marginRight: "0.7rem",
              cursor: "pointer",
            }}
          />
          <h5 style={{ marginRight: "4rem" }}>Language To Teach Details</h5>
        </div>
        <div className="section">
          <div className={style.textWrapper}>
            <h5>First name</h5>
            <p className={style.textStyle}>
              {languageTaught?.merchantFirstName}
            </p>
          </div>

          <div className={style.textWrapper}>
            <h5> User email</h5>
            <p className={style.textStyle}>
              {languageTaught?.merchantTeacherEmail}
            </p>
          </div>

          <div className={style.textWrapper}>
            <h5>Requested Date</h5>
            <p className={style.textStyle}>
              {formatDate((languageTaught?.requestedAt as any) ?? null)}
            </p>
          </div>

          <div className={style.textWraperRowStyle}>
            <div className={style.textWrapper}>
              <h5>Language</h5>
              <p className={style.textStyle}>
                {languageTaught?.language?.map((item) => item.language)}
              </p>
            </div>

            <div className={style.textWrapper}>
              <h5>Proficiency Level</h5>
              <p className={style.textStyle}>
                {languageTaught?.language?.map((item) => item.proficiency)}
              </p>
            </div>
          </div>

          <hr
            style={{
              marginTop: "1rem",
              marginBottom: "2rem",
              fontWeight: "lighter",
            }}
          />
          <div className="dashboard-button">
            <Button
              name="Approve"
              type="activate-button"
              isLoading={action === "approve"}
              loadingText="Approving..."
              onClick={() => handleStatusUpdate(ActionType.ACCEPTED, "approve")}
            />
            <Button
              name="Reject"
              type="delete-button"
              isLoading={action === "reject"}
              loadingText="Rejecting..."
              onClick={() => handleStatusUpdate(ActionType.REJECT, "reject")}
            />
          </div>
        </div>
      </>
    </Dashboard>
  );
}
